import { useEffect } from "react";
import PageHeader from "../components/PageHeader";

const SECTIONS = [
  {
    h: "Information We Collect",
    p: "We collect information you voluntarily provide when you contact us, book a consultation, or subscribe to our newsletter — such as your name and email address. We do not request account passwords or sensitive credentials.",
  },
  {
    h: "How We Use Your Information",
    p: "We use your information to respond to inquiries, deliver consulting services, schedule sessions, and send occasional updates you have opted into. We do not sell your personal information.",
  },
  {
    h: "Data Retention",
    p: "We retain your information only as long as necessary to provide our services and comply with legal obligations. You may request deletion of your data at any time.",
  },
  {
    h: "Third-Party Platforms",
    p: "Our guidance references publicly available platform features and policies. We are not affiliated with, or endorsed by, any third-party platform, and we do not access accounts on your behalf without explicit arrangement.",
  },
  {
    h: "Your Rights",
    p: "You may request access to, correction of, or deletion of your personal data by contacting us. We will respond within a reasonable timeframe.",
  },
  {
    h: "Contact",
    p: "For any privacy questions or requests, please email joblsx.consulting@gmail.com.",
  },
];

export default function Privacy() {
  useEffect(() => {
    document.title = "Privacy Policy — JOBLSX";
  }, []);
  return (
    <div>
      <PageHeader overline="Legal" title="Privacy Policy" subtitle="How we handle and protect your information." />
      <section className="pb-24 pt-8">
        <div className="mx-auto max-w-3xl px-6 md:px-12">
          <div className="space-y-10">
            {SECTIONS.map((s) => (
              <div key={s.h}>
                <h2 className="font-display text-2xl font-medium tracking-tight">{s.h}</h2>
                <p className="mt-3 leading-relaxed text-slate-400">{s.p}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
